import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Create root element if it doesn't exist
const rootElement = document.getElementById('root');
if (!rootElement) {
  const root = document.createElement('div');
  root.id = 'root';
  document.body.appendChild(root);
}

// 确保使用React.createElement而不是jsxDEV
const app = React.createElement(
  React.StrictMode, 
  null, 
  React.createElement(App, null)
);

ReactDOM.createRoot(document.getElementById('root')!).render(app);
